export const PRE_ACCOUNT_VALIDATION_ACTION = "password-reset/PRE_ACCOUNT_VALIDATION_ACTION";

export default function preAccountValidationAction() {
  return {
    "payload": {},
    "type": PRE_ACCOUNT_VALIDATION_ACTION
  };
}
